import { FavoriteStatus } from '@app/data/clients/listsClient/types';
import { HomepageWork } from '@app/data/clients/monolithClients/explore/types';
import { FavoritesInput } from '@app/data/lists';
import { getFavoriteStatuses } from '@app/utils/favorites';
import logger from '@redbubble/next/logger';
import { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import { useCallback, useRef, useState } from 'react';

const mapWorkIds = (workItems: HomepageWork[]): FavoritesInput => {
  return {
    workIds: workItems.map((work) => work.id.toString()),
  };
};

// Currently this only works with works as it was initially built for the homepage works
// carousel. The intent is for this to be extended to also allow managing inventoryItems
// in lists as well as supported by the lists api. This will need to be extended in the future to enable this.

export const useFavoriteStatuses = () => {
  const [{ isLoggedIn }] = useUserInfo<UserInfo>();
  const [favoriteStatuses, setFavoriteStatuses] = useState<
    FavoriteStatus[] | null
  >(null);

  const itemRef = useRef<string>(JSON.stringify([]));
  const refresh = useCallback((workItems: HomepageWork[]) => {
    //need to add method to map for inventoryItemIds
    const workIds = mapWorkIds(workItems);
    const itemJson = JSON.stringify(workIds);
    if (itemJson === itemRef.current) {
      return;
    }

    itemRef.current = itemJson;
    getFavoriteStatuses({ favorites: workIds })
      .then((res) => {
        if (res) {
          setFavoriteStatuses(res);
        }
      })
      .catch((error) => {
        const message = 'Failed to fetch favorite statuses';
        logger.error(
          { err: error, context: 'useFavoriteStatuses', message },
          message
        );
        setFavoriteStatuses(null);
      });
  }, []);

  if (!isLoggedIn) {
    return {
      favoriteStatuses: null,
      refresh: () => {},
    };
  }
  return {
    favoriteStatuses,
    refresh,
  };
};
